import { SMART_SERVICE_TERMS } from './smartServiceTerms';
import {
  SmartServiceTermsContent,
  SmartServiceTermsPage as TermsPageContainer,
  SmartServiceTermsText,
  SmartServiceTermsTitle,
} from './styles/components';

export default function SmartServiceTermsPage() {
  return (
    <TermsPageContainer component="main">
      <SmartServiceTermsContent>
        <SmartServiceTermsTitle>Smart Service Terms &amp; Conditions</SmartServiceTermsTitle>
        {SMART_SERVICE_TERMS.map((term, index) => (
          <SmartServiceTermsText key={`smart-service-term-${index}`}>
            {term}
          </SmartServiceTermsText>
        ))}
      </SmartServiceTermsContent>
    </TermsPageContainer>
  );
}
